module.exports = __webpack_public_path__ + "static/table-dbfb64cd5f1c98ba93b773c9d0822a4f.jpg";